import React, { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { lang, img_url, page_url } from './../lang'
// import { useNavigate } from 'react-router-dom';
// import SwiperNavigation from "../Template/Swiper/SwiperNavigation";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import api from '../api'

SwiperCore.use([Navigation, Pagination]);
export default function Slide(props) {
    const [images, setImages] = useState([]);
	// const navigate = useNavigate();
    const styles = props.styles;
    SwiperCore.use([Autoplay]); // start autoplay

    useEffect(()=>{
        const fetchInit = async () =>{
            try {
                let article_id = 1;
              const response = await api.get('/gallery/'+article_id);
              setImages(response.data.results);
            } catch (err) {
                if(err.response){
                    //Not in 202 response range
                    console.log(err.response.data);
                    console.log(err.response.headers);
                    console.log(err.response.status);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
        }
        fetchInit();
    },[]);

    return (
        <>
        <div className="slide-container">
            {/* group items  */}
            <Swiper
                spaceBetween={5}
                slidesPerView={1}
                speed={900}
                autoplay={{ delay: 3000 }}
                pagination={{
                  type: "progressbar",
                }}
                modules={[Pagination]}
                className="slide-swiper"
            >
                {images.map((item, index) => (
                    <SwiperSlide className="swiper-slide" key={index}>
                        <div className={"card "}>
                            <div className={"image"}>
                                <div className={"image-inner"} style={{ backgroundImage: `url('${img_url + item.url}')` }}></div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
        </>
    )
}
